// ─── What: the furniture every sub-panel shares ───────────────────────────────
//
// A clickable label that toggles the panel open. The original had three
// near-identical copies of this, one per panel.

import type { ChartGroup, ChartSvg } from '../drawContext';

export interface PanelToggleOpts {
    /** Panel content top; the label sits 5px above it. */
    top: number;
    /** Plot centre x. */
    centreX: number;
    /** Panel name, upper case. The chevron is appended here. */
    name: string;
    open: boolean;
    textColor: string;
    onToggle: () => void;
}

/**
 * Returns the group so callers can append siblings belonging to the same heading
 * row (the conviction panel's RAW/LOCF pill).
 */
export function drawPanelToggle(
    svg: ChartSvg,
    opts: PanelToggleOpts
): ChartGroup {
    const labelG = svg
        .append('g')
        .style('cursor', 'pointer')
        .on('click', opts.onToggle) as ChartGroup;

    labelG
        .append('text')
        .attr('x', opts.centreX)
        .attr('y', opts.top - 5)
        .attr('fill', opts.textColor)
        .attr('font-size', '8px')
        .attr('font-family', 'monospace')
        .attr('font-weight', 600)
        .attr('text-anchor', 'middle')
        .text(`${opts.name} ${opts.open ? '▾' : '▸'}`);

    return labelG;
}
